var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Axios from 'axios';
import { differenceInDays, isValid } from 'date-fns';
import { useState, useEffect } from 'react';
import md5 from 'md5';
import { option2Trans, isDate, isString, zeroFirst } from 'component/consts';
import DateEnum, { dDaFms } from 'component/material/DatePicker/enum';
import { warningSnack, successSnack } from 'component/config';
// #region options ------------------------------------------------------------------------------------------
export var YNOpTrs = option2Trans([
    { value: 'Y', label: '是' },
    { value: 'N', label: '不是' },
]);
export var YN2OpTrs = option2Trans([
    { value: 'Y', label: '是' },
    { value: 'N', label: '否' },
]);
export var langOpTrs = option2Trans([
    { value: 'US', label: '英文' },
    { value: 'TW', label: '中文' },
]);
export var ieTypeOpTrs = option2Trans([
    { value: 'I', label: '進口' },
    { value: 'E', label: '出口' },
]);
export var certificateTypeOpTrs = option2Trans([
    { value: 'C', label: '身分證' },
    { value: 'R', label: '居留證' },
    { value: 'O', label: '其他' },
]);
export var imgCodeOpTrs = option2Trans([
    { value: 'A', label: '證件正面' },
    { value: 'B', label: '證件反面' },
    { value: 'C', label: '委任書簽名' },
    { value: 'D', label: '其他文件1' },
    { value: 'E', label: '其他文件2' },
    { value: 'F', label: '其他文件3' },
    { value: 'G', label: '其他文件4' },
    { value: 'H', label: '其他文件5' },
    { value: 'P', label: '個案委任書PDF' },
]);
export var verifyFlagOpTrs = option2Trans([
    { value: 'Y', label: '已實名' },
    { value: 'N', label: '未實名' },
    { value: '', label: '未實名' },
]);
// #endregion
// #region function -----------------------------------------------------------------------------------------
export var strMask = function (str, head, tail) {
    if (str === void 0) { str = ''; }
    if (head === void 0) { head = 3; }
    if (tail === void 0) { tail = head; }
    return str
        .trim()
        .split('')
        .map(function (char, idx) {
        return idx > head - 1 && idx < str.length - tail ? '*' : char;
    })
        .join('');
};
var generateRandomString = function (length, randomString) {
    if (length === void 0) { length = 12; }
    if (randomString === void 0) { randomString = ''; }
    var str = randomString;
    str += Math.random().toString(20).substr(2, length);
    return str.length >= length
        ? str.slice(0, length)
        : generateRandomString(length, str);
};
export var EzToken = function () {
    // const UTC = new Date().getTime() + new Date().getTimezoneOffset() * 60 * 1000;
    // const timestamp = Math.floor((UTC - (-480) * 60 * 1000) / 1000);
    var salt = generateRandomString();
    var timestamp = String(Math.floor(new Date().getTime() / 1000));
    return [timestamp, "" + salt + md5("" + salt + timestamp + "+xH9x!&")];
};
var timer;
export var timerDebounce = function (func, delay) {
    if (delay === void 0) { delay = 1000; }
    if (timer) {
        clearInterval(timer);
    }
    timer = setTimeout(func, delay);
};
// #endregion
// #region dataproccess -------------------------
// 時間起迄需同時有值或同時空值
export var startEndErrMsg = function (a, b) {
    return (a && !b) || (!a && b) ? '請輸入完整起迄日期。' : '';
};
export var requiredOne = function (v) {
    return v.some(function (e) { return (e || '').length > 0; });
};
export var keepFieldVal = function (newArray, oldArray, idField, keepFields) {
    if (idField === void 0) { idField = ''; }
    var returnArray = __spreadArrays(newArray);
    oldArray.forEach(function (oldObj) {
        var tempIdx = newArray.findIndex(function (newObj) { return newObj[idField] === oldObj[idField]; });
        if (tempIdx > -1) {
            keepFields.forEach(function (field) {
                returnArray[tempIdx][field] = oldObj[field];
            });
        }
    });
    return returnArray;
};
// export function dateFormatTrans(
//   value: string | null,
//   dateFormat?: DateEnum
// ): Date | null;
// export function dateFormatTrans(
//   value: Date | null,
//   dateFormat?: DateEnum
// ): string | null;
export function daFormatTrans(value, dateFormat) {
    if (dateFormat === void 0) { dateFormat = DateEnum.daFormat; }
    if (isDate(value) && isValid(value)) {
        var valueD = value;
        var y = zeroFirst(valueD.getFullYear(), -4);
        var m = zeroFirst(valueD.getMonth() + 1, -2);
        var d = zeroFirst(valueD.getDate(), -2);
        var HH = zeroFirst(valueD.getHours(), -2);
        var mm = zeroFirst(valueD.getMinutes(), -2);
        var ss = zeroFirst(valueD.getSeconds(), -2);
        if (y && m && d && HH && mm && ss) {
            switch (dateFormat) {
                case DateEnum.daTiFormat:
                    return y + m + d + " " + HH + mm + ss;
                case DateEnum.daTiFormatN:
                    return y + m + d + HH + mm + ss;
                case DateEnum.daTiFormatP:
                    return y + "/" + m + "/" + d + " " + HH + ":" + mm + ":" + ss;
                case DateEnum.daTi4Format:
                    return y + m + d + " " + HH + mm;
                case DateEnum.daTi4FormatP:
                    return y + "/" + m + "/" + d + " " + HH + ":" + mm;
                case DateEnum.daFormatP:
                    return y + "/" + m + "/" + d;
                case DateEnum.daFormat:
                    return y + m + d;
                case DateEnum.tiFormatP:
                    return HH + ":" + mm + ":" + ss;
                case DateEnum.tiFormat:
                    return HH + mm + ss;
                case DateEnum.ti4FormatP:
                    return HH + ":" + mm;
                case DateEnum.ti4Format:
                    return HH + mm;
                default:
                    return null;
            }
        }
    }
    else if (isString(value) && value.length > 0) {
        var date = new Date();
        var y = Number(value.slice(0, 4));
        var m = Number(value.slice(5, 7)) - 1;
        var d = Number(value.slice(8, 10));
        var HH = Number(value.slice(-8, -6));
        var mm = Number(value.slice(-5, -3));
        var ss = Number(value.slice(-2));
        switch (dateFormat) {
            case DateEnum.daTiFormat:
            case DateEnum.daTiFormatN:
                date = new Date(y, Number(value.slice(4, 6)) - 1, Number(value.slice(6, 8)), Number(value.slice(-6, -4)), Number(value.slice(-4, -2)), ss);
                break;
            case DateEnum.daTiFormatP:
                date = new Date(y, m, d, HH, mm, ss);
                break;
            case DateEnum.daTi4Format:
                date = new Date(y, Number(value.slice(4, 6)) - 1, Number(value.slice(6, 8)), Number(value.slice(-4, -2)), Number(value.slice(-2)), 0);
                break;
            case DateEnum.daTi4FormatP:
                date = new Date(y, m, d, HH, mm);
                break;
            case DateEnum.daFormatP:
                date = new Date(y, m, d);
                break;
            case DateEnum.daFormat:
                date = new Date(y, Number(value.slice(4, 6)) - 1, Number(value.slice(-2)));
                break;
            case DateEnum.tiFormatP:
                date.setHours(HH);
                date.setMinutes(mm);
                date.setSeconds(ss);
                break;
            case DateEnum.tiFormat:
                date.setHours(Number(value.slice(-6, -4)));
                date.setMinutes(Number(value.slice(-4, -2)));
                date.setSeconds(Number(value.slice(-2)));
                break;
            case DateEnum.ti4FormatP:
                date.setHours(HH);
                date.setMinutes(mm);
                break;
            case DateEnum.ti4Format:
                date.setHours(Number(value.slice(-4, -2)));
                date.setMinutes(Number(value.slice(-2)));
                break;
            default:
                break;
        }
        if (dateFormat.slice(0, 4) === 'YYYY') {
            date.setFullYear(y);
        }
        if (isValid(date)) {
            return date;
        }
    }
    return null;
}
export var getDateDayPlus = function (plusDay, nowDate, DateFormat) {
    if (plusDay === void 0) { plusDay = 0; }
    if (nowDate === void 0) { nowDate = new Date(); }
    if (DateFormat === void 0) { DateFormat = DateEnum.daFormat; }
    var localNowDate = new Date(nowDate.getTime());
    var plusDayTemp = plusDay;
    if (plusDay > 0) {
        plusDayTemp -= 1;
    } // 當天也算一天
    else if (plusDay < 0) {
        plusDayTemp += 1;
    }
    localNowDate.setDate(localNowDate.getDate() + plusDayTemp);
    return daFormatTrans(localNowDate, DateFormat);
};
// 1. check start < end
// 2. check interval
export var seDateVerify = function (name, date, seStr, data, updateData, enqueueSnackbar, interval, dateFormat) {
    var _a, _b, _c, _d;
    if (interval === void 0) { interval = 0; }
    if (dateFormat === void 0) { dateFormat = DateEnum.daFormat; }
    var dataTemp = data;
    var isStart = name === seStr[0];
    var isEnd = name === seStr[1];
    // maybe empty
    var startDate = isStart
        ? date
        : daFormatTrans(dataTemp[seStr[0]], dateFormat);
    var endDate = isEnd
        ? date
        : daFormatTrans(dataTemp[seStr[1]], dateFormat);
    if (!isDate(startDate) || !isDate(endDate)) {
        return false;
    }
    var startDateD = startDate;
    var endDateD = endDate;
    // check start < end
    if (startDateD > endDateD) {
        if (isStart) {
            updateData((_a = {},
                _a[seStr[0]] = daFormatTrans(startDateD, dateFormat),
                _a[seStr[1]] = getDateDayPlus(interval, startDateD),
                _a));
        }
        else if (isEnd) {
            updateData((_b = {},
                _b[seStr[0]] = getDateDayPlus(-interval, endDateD),
                _b[seStr[1]] = daFormatTrans(endDateD, dateFormat),
                _b));
        }
        enqueueSnackbar('起始日期不得大於結束日期。');
        return false;
    }
    // check interval
    if (interval && differenceInDays(endDateD, startDateD) > interval - 1) {
        if (isStart) {
            updateData((_c = {},
                _c[seStr[0]] = daFormatTrans(startDateD, dateFormat),
                _c[seStr[1]] = getDateDayPlus(interval, startDateD),
                _c));
        }
        else if (isEnd) {
            updateData((_d = {},
                _d[seStr[0]] = getDateDayPlus(-interval, endDateD),
                _d[seStr[1]] = daFormatTrans(endDateD, dateFormat),
                _d));
        }
        enqueueSnackbar("\u65E5\u671F\u9593\u8DDD\u4E0D\u5F97\u5927\u65BC" + interval + "\u65E5\u3002");
        return false;
    }
    return true;
};
export var dateTransSerial = function (value, formats) {
    if (value === void 0) { value = ''; }
    if (formats === void 0) { formats = dDaFms; }
    var reVal = value;
    formats.forEach(function (obj) {
        reVal = daFormatTrans(reVal, obj);
    });
    return reVal;
};
export var clearEmptyKey = function (dataTemp) {
    var data = __assign({}, dataTemp);
    var reData = {};
    Object.keys(data).forEach(function (name) {
        if (data[name] || data[name] === 0) {
            reData[name] = data[name];
        }
    });
    return reData;
};
// #endregion
// #region window ----------------------------------------------------
export var useWindowSize = function () {
    var isClient = typeof window === 'object';
    var getSize = function () { return ({
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined,
    }); };
    var _a = useState(getSize), windowSize = _a[0], setWindowSize = _a[1];
    useEffect(function () {
        if (!isClient) {
            return;
        }
        var handleResize = function () { return setWindowSize(getSize()); };
        window.addEventListener('resize', handleResize);
        // eslint-disable-next-line consistent-return
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
// #endregion
// #region Axios ----------------------------------------------------------------------------------
export var goAxios = function (method, url, dataTemp, enqueueSnackbar, config, emptyClear) {
    if (config === void 0) { config = {}; }
    if (emptyClear === void 0) { emptyClear = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var data, response, methodL, _a, error_1, errorTemp, _b, data, status;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 8, , 9]);
                    data = emptyClear ? clearEmptyKey(dataTemp) : dataTemp;
                    response = void 0;
                    methodL = method.toLowerCase();
                    _a = methodL;
                    switch (_a) {
                        case 'get': return [3 /*break*/, 1];
                        case 'delete': return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, Axios[methodL](url, __assign({ params: data }, config))];
                case 2:
                    response = _c.sent();
                    return [3 /*break*/, 7];
                case 3: return [4 /*yield*/, Axios[methodL](url, __assign({ data: data }, config))];
                case 4:
                    response = _c.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, Axios[methodL](url, data, config)];
                case 6:
                    response = _c.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, response];
                case 8:
                    error_1 = _c.sent();
                    errorTemp = error_1;
                    if (errorTemp === null || errorTemp === void 0 ? void 0 : errorTemp.response) {
                        _b = errorTemp.response, data = _b.data, status = _b.status;
                        // token失效，更新後直接重發 axios
                        if (status === 401 && data.status === 'O') {
                            window.sessionStorage.setItem('jwt', "Bearer " + data.data);
                            Axios.defaults.headers.Authorization = "Bearer " + data.data;
                            return [2 /*return*/, goAxios(method, url, dataTemp, enqueueSnackbar, config)];
                        }
                    }
                    if (enqueueSnackbar) {
                        enqueueSnackbar('系統忙碌中，請稍後再試...');
                    }
                    return [2 /*return*/, undefined];
                case 9: return [2 /*return*/];
            }
        });
    });
};
export var dAxios = function (method, url, data, enqueueSnackbar, config, emptyClear) {
    if (config === void 0) { config = {}; }
    if (emptyClear === void 0) { emptyClear = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, Timestamp, Sign, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = EzToken(), Timestamp = _a[0], Sign = _a[1];
                    Axios.defaults.headers.Timestamp = Timestamp;
                    Axios.defaults.headers.Sign = Sign;
                    return [4 /*yield*/, goAxios(method, url, data, enqueueSnackbar, config, emptyClear)];
                case 1:
                    response = _b.sent();
                    // if (response && response.data.status === "O") {
                    //     window.sessionStorage.setItem("jwt", "Bearer " + response.data.data);
                    //     Axios.defaults.headers.Authorization = "Bearer " + response.data.data;
                    //     return await goAxios(method, url, data, enqueueSnackbar, consoleStr, config)
                    // }
                    // else
                    return [2 /*return*/, response];
            }
        });
    });
};
export var formAxios = function (method, url, data, enqueueSnackbar, config, emptyClear) {
    if (emptyClear === void 0) { emptyClear = false; }
    var formData = new FormData();
    Object.keys(data).forEach(function (obj) {
        if (data[obj])
            formData.append(obj, data[obj]);
    });
    var _a = (config || {}).headers, headers = _a === void 0 ? {} : _a;
    return dAxios(method, url, formData, enqueueSnackbar, __assign(__assign({}, config), { headers: __assign(__assign({}, headers), { 'Content-Type': 'multipart/form-data' }) }), emptyClear);
};
export var snackBarRsp = function (enqueueSnackbar, response, successNoShow) {
    if (successNoShow === void 0) { successNoShow = false; }
    if (!response || response.data.msg === '伺服器發生未知錯誤，請稍後再試') {
        enqueueSnackbar('系統忙碌中，請稍後再試...');
        return false;
    }
    var data = response.data;
    // E: 異常
    // Y: 有資料
    // N: 無資料、設定
    if (successNoShow && data.status !== 'E') {
        return true;
    }
    if (data.msg) {
        enqueueSnackbar(data.msg, data.status === 'Y' ? successSnack : warningSnack);
    }
    return true;
};
export var blobDownload = function (response, enqueueSnackbar, _fileName) {
    // { responseType: "blob" }
    var fileName = _fileName;
    if (!fileName) {
        if (!response.headers['content-disposition']) {
            if (response.headers.body) {
                try {
                    var res = JSON.parse(decodeURIComponent(response.headers.body));
                    enqueueSnackbar(res.msg);
                }
                catch (e) {
                    // console.log(e)
                    enqueueSnackbar('系統忙碌中，請稍後再試...');
                }
            }
            return;
        }
        fileName = response.headers['content-disposition']
            .split('=')[1]
            .replace(/"/g, '');
    }
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([response.data]));
    link.setAttribute('download', fileName || ''); // or any other extension
    document.body.appendChild(link);
    link.click();
};
export var pdfBlank = function (response, enqueueSnackbar) {
    // { responseType: "arraybuffer" }
    if (!response) {
        enqueueSnackbar('系統忙碌中，請稍後再試...', warningSnack);
        return;
    }
    window.open(window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' })));
};
// #endregion
